import React from "react";

// A stale bundle after a deploy throws a ChunkLoadError when the browser asks
// for a hashed chunk that no longer exists. Detect it so we can reload once into
// the current build instead of showing a blank page.
export function isChunkError(err) {
  const msg = (err && (err.message || String(err))) || "";
  return (
    (err && err.name === "ChunkLoadError") ||
    /Loading chunk [\w-]+ failed/i.test(msg) ||
    /Loading CSS chunk/i.test(msg) ||
    /dynamically imported module/i.test(msg) ||
    /import\(\) failed/i.test(msg)
  );
}

// Reload at most once per browser session so a genuinely-missing asset can't
// trap the user in a reload loop.
export function reloadOnceForChunkError() {
  try {
    if (!sessionStorage.getItem("vtx-chunk-reload")) {
      sessionStorage.setItem("vtx-chunk-reload", "1");
      window.location.reload();
      return true;
    }
  } catch { /* sessionStorage blocked — fall through to the fallback UI */ }
  return false;
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (isChunkError(error) && reloadOnceForChunkError()) return;
    // eslint-disable-next-line no-console
    console.error("Unhandled UI error:", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const chunk = isChunkError(this.state.error);
    return (
      <div style={{
        minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
        padding: 24, fontFamily: "Helvetica, Arial, sans-serif", background: "#F4FEFF", color: "#0f172a",
      }}>
        <div style={{
          maxWidth: 440, textAlign: "center", background: "#fff", border: "1px solid #A9C0E0",
          borderRadius: 4, padding: 32,
        }}>
          <div style={{ fontWeight: 800, letterSpacing: 0.5, fontSize: 18, color: "#0E2F76" }}>VENTRIX</div>
          <h1 style={{ fontSize: 20, fontWeight: 800, color: "#0E2F76", margin: "16px 0 8px" }}>
            {chunk ? "A new version is available" : "Something went wrong"}
          </h1>
          <p style={{ fontSize: 14, color: "#475569", lineHeight: 1.6, margin: 0 }}>
            {chunk
              ? "The app was updated. Reload to get the latest version."
              : "An unexpected error occurred while loading this page. Reloading usually fixes it."}
          </p>
          <button
            onClick={() => { try { sessionStorage.removeItem("vtx-chunk-reload"); } catch {} window.location.reload(); }}
            style={{
              marginTop: 20, background: "#0E2F76", color: "#fff", border: "none", cursor: "pointer",
              fontWeight: 700, fontSize: 14, padding: "11px 22px", borderRadius: 2,
            }}
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
